import React from 'react';
import { Link } from 'chic-ui';
import { Row } from 'react-bootstrap';
import Disabled from './Disabled';

const LinkComponent = () => {
  return (
    <div className="m-3">
      <h3>Links</h3>
      <p>Use <i>href</i> to specify the URL. Links can also be used as custom elements by using the <i>as</i> prop.</p>
      <div className="btn-group btns mt-3">
        <Link className="single-btn" href="https://github.com/karishmashuklaa/chic-ui">
          Link to Chic-UI Repository
        </Link>
      </div>
      <Row className="mt-3" fluid>
        <code>
          {'import { Link } from "chic-ui";'}
          <br />
          {'<Link href="https://github.com/karishmashuklaa/chic-ui">Link to Chic-UI Repository</Link>'}
        </code>
      </Row>
      <Disabled />
    </div>
  );
};

export default LinkComponent;
